import React from 'react';
import IconButton from '@mui/material/IconButton';
import UndoIcon from '@mui/icons-material/Undo';

import { playSound } from 'src/modules/soundHandler';

import styles from './BackButton.module.scss';

interface BackButtonPropsInterface {
  onClick: () => any;
  [key: string]: any;
}

const BackButton = ({ onClick, ...otherProps }: BackButtonPropsInterface) => {
  const buttonClick = () => {
    onClick && onClick();
    playSound('backClick');
  };

  return (
    <IconButton
      title="Go back"
      size="small"
      className={styles.BackButton}
      onClick={buttonClick}
      {...otherProps}
    >
      <UndoIcon fontSize="small" />
    </IconButton>
  );
};

export default BackButton;
